import React from 'react'
import * as S from './Project.styles'
import { projectsPortfolio } from './ProjectsData'
import GitHubLogo from '../../png-extras/github2.png'
import WebsiteLogo from '../../png-extras/website2.png'

const Projects = () => {

    window.addEventListener('scroll', function () {
        let animacionProjects = document.getElementById("projects")
        let posicionOb2 = animacionProjects.getBoundingClientRect().top
        let tamañoDePantalla = window.innerHeight / 1.25

        if (posicionOb2 < tamañoDePantalla) {
            animacionProjects.style.animation = "fadeInProjects 1s ease-out forwards"
        }
    })

    return (
        <S.Projects id='projects'>
            <S.Title>
                Some of
                <span>
                    <br />
                    My Projects
                </span>
            </S.Title>
            <S.ContentProjects>
                {projectsPortfolio.map((project, index) => (
                    <S.projectContent key={index}>
                        <S.TitleAndImage>
                            <a href={project.website} target='_blank' rel='noreferrer'>
                                <S.ContainerImage>
                                    <img src={project.image} alt={project.title} loazy="true" />
                                </S.ContainerImage>
                            </a>
                            <S.TitleProject>
                                {project.title}
                            </S.TitleProject>
                        </S.TitleAndImage>
                        <S.ContainerTechs>
                            {project.techs.map((tech, index) => (
                                <div key={index}>
                                    <img src={tech.src} alt={tech.name} />
                                    <p>{tech.name}</p>
                                </div>
                            ))}
                        </S.ContainerTechs>
                        <S.Description>
                            {project.description}
                        </S.Description>
                        <S.ContainerFooter>
                            {project.repository && (
                                <a href={project.repository} target='_blank' rel='noreferrer'>
                                    <img src={GitHubLogo} alt={project.description} />
                                </a>
                            )}
                            {project.website && (
                                <a href={project.website} target='_blank' rel='noreferrer'>
                                    <img src={WebsiteLogo} alt={project.description} />
                                </a>
                            )}
                        </S.ContainerFooter>
                    </S.projectContent>
                ))}
            </S.ContentProjects>
        </S.Projects>
    )
}

export default Projects